<template>
  <v-container fluid>
    <InspectionsTable class="pb-4">
      <template v-slot:actions="{ dataset }">
        <avs-exportButton
          :data="dataset"
          :prepare="preFmtData"
          :name="$t('actions.export_')"
          :spantext="
            $t('actions.export', {
              entity: $tc('categories.inspection.name', 2).toLowerCase()
            })
          "
        />
        <avs-createButton
          menu
          :name="$t('actions.new_female', { entity: $tc('categories.inspection.name', 1) })"
          :spantext="
            $t('actions.create', {
              entity: $tc('categories.inspection.name', 1).toLowerCase()
            })
          "
        >
          <template v-slot:list>
            <v-list>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, i) in newMenuItems"
                  :key="i"
                  @click="item.function()"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </template>
        </avs-createButton>
      </template>
    </InspectionsTable>
  </v-container>
</template>
<script>
import InspectionsTable from "@/components/ri3/inspection/InspectionsTable.vue"
import InspectionService from "@/services/InspectionService"
import { now, add } from "@/utils/datetime"
import { fmtInspectionData } from "@/utils/download"

export default {
  name: "InspectionsView",
  components: { InspectionsTable },
  computed: {
    project() {
      return this.$store.state.app.project
    }
  },
  data() {
    return {
      loading: false,
      newMenuItems: [
        {
          text: this.$t("categories.inspection.quick"),
          icon: "mdi-clipboard-text-clock-outline",
          function: this.handleNewMeeting
        },
        {
          text: this.$t("categories.inspection.plan"),
          icon: "mdi-calendar-cursor",
          function: this.handleNewInspection
        },
        {
          text: this.$t("categories.inspection.fill"),
          icon: "mdi-file-document-edit-outline",
          function: this.handleNewInspectionForm
        }
      ]
    }
  },
  methods: {
    createInspection(redirectPath, tab = null, notify = false) {
      this.loading = true
      const startDate = now()
      const endDate = add(now(), 1, "h")
      InspectionService.create(this, this.project.id, {
        name: "NONE",
        start_date: startDate,
        end_date: endDate,
        status: "Ongoing",
        notify_oncreated: notify
      })
        .then(r => {
          this.$store.commit("app/message", {
            msg: this.$t("messages.success.created", {
              entity: this.$tc("categories.inspection.name", 1)
            }),
            color: "success"
          })
          this.$router.push({
            name: redirectPath,
            params: { id: r.id, uuid: r.uuid, tab: tab }
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleNewInspection() {
      this.$router.push({
        name: "InspectionCreateUpdate"
      })
    },
    handleNewInspectionForm() {
      this.createInspection("Inspection", 2)
    },
    handleNewMeeting() {
      this.createInspection("InspectionMeeting", null, false)
    },
    preFmtData(dataset) {
      return fmtInspectionData(dataset)
    }
  }
}
</script>
